import { DateTime } from "luxon";
import { IAvailability } from "../../types/availabilities/Availabilities";
import AvailabilitiesApi from "../api/availabilitiesApi";
import * as types from "./actionTypes";

function getMyAvailabilitiesStarted() {
  return { type: types.AVAILABILITIES_GET_MY_STARTED };
}
function getMyAvailabilitiesFulfilled(avails: IAvailability[]) {
  return { type: types.AVAILABILITIES_GET_MY_FULFILLED, payload: avails };
}
function getMyAvailabilitiesRejected(error: any) {
  return {
    type: types.AVAILABILITIES_GET_MY_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function deleteAvailabilityFulfilled(availability: any) {
  return { type: types.AVAILABILITIES_DELETE_FULFILLED, payload: availability };
}

export function createUnavailabilityFulfilled(availability: any) {
  return { type: types.AVAILABILITIES_CREATE_FULFILLED, payload: availability };
}

export function getAvailabilitiesFulfilled(person: string, availabilities: IAvailability[]) {
  return {
    type: types.AVAILABILITIES_GET_FULFILLED,
    payload: { person, availabilities },
  };
}

export function getAvailabilities(
  person: string, options: { shiftContext?: string, start?: DateTime },
): (dispatch: any) => Promise<IAvailability[]> {
  return (dispatch: any) =>
    AvailabilitiesApi.getAvailabilities(person, options).then((avs) => {
      dispatch(getAvailabilitiesFulfilled(person, avs));
      return avs;
    });
}

export function getMyAvailabilities(): (dispatch: any) => Promise<IAvailability[]> {
  return (dispatch: any) => {
    dispatch(getMyAvailabilitiesStarted());
    return AvailabilitiesApi.getMyActivities()
      .then((avs) => {
        dispatch(getMyAvailabilitiesFulfilled(avs));
        return avs;
      })
      .catch((er) => {
        dispatch(getMyAvailabilitiesRejected(er));
        throw er;
      });
  };
}

export function createUnavailability(
  availability: IAvailability,
): (dispatch: any) => Promise<IAvailability> {
  return (dispatch: any) =>
    AvailabilitiesApi.createUnavailability(availability).then((avail) => {
      dispatch(createUnavailabilityFulfilled(avail));
      return avail;
    });
}

export function deleteAvailability(availabilityId: string) {
  return (dispatch: any) =>
    AvailabilitiesApi.deleteAvailability(availabilityId).then((avail) => {
      dispatch(deleteAvailabilityFulfilled(avail));
      return avail;
    });
}
